import React, { FC } from 'react';
import { Button, ButtonSize, ButtonSkin } from '@wix/design-system';
import { Template } from '../../domain/entities/template';
import { useTranslation } from '@wix/wix-i18n-config';
import { useViewUrl } from '../../hooks/useViewUrl';
import { useBiLogger } from '../../contexts/BILoggerContext';

interface ViewButtonProps {
  template: Template;
  skin: ButtonSkin;
  size?: ButtonSize;
  index?: number;
  dataHook?: string;
  className?: string;
  tabName?: string;
  categorySlug?: string;
}

export const ViewButton: FC<ViewButtonProps> = ({
  template,
  index,
  dataHook,
  skin,
  size = 'large',
  className,
  tabName,
  categorySlug,
}) => {
  const { t } = useTranslation();
  const viewUrl = useViewUrl(template);
  const biLogger = useBiLogger();

  const onViewClick = () => {
    biLogger.reportViewTemplate({ ...template, index, categorySlug, tabName });
  };

  return (
    <Button
      as="a"
      priority="secondary"
      size={size}
      target="_blank"
      skin={skin}
      className={className}
      onClick={onViewClick}
      href={viewUrl}
      dataHook={dataHook}
    >
      {t('app.templates.grid.view.button')}
    </Button>
  );
};
